module.exports = __webpack_public_path__ + "img/Speaker=David Thompson.1b2bc632.png";